import { IMG } from '../../../lib/dom';
export function playerAvatar(p) {
    var anonSrc = require('./img/anonymous.png');
    if (isAnonymous(p)) {
        return new IMG({ attrs: { src: anonSrc, class: 'anonymous' } });
    }
    else {
        var img_1 = new IMG({
            attrs: FOR_YANDEX ? { src: 'medium', srcset: p.getAvatarSrcSet('small') } : { src: p.avatar },
            onError: function () { return (img_1.src = anonSrc); },
        });
        return img_1;
    }
}
function isAnonymous(player) {
    if (FOR_YANDEX) {
        return player.scopePermissions.avatar !== 'allow';
    }
    else if (FOR_VK) {
        return !player.avatar || player.avatar.includes('camera_100.png');
    }
    return true;
}
